export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;

  console.log(dragResult);
  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];

  let modifyAbleRemovedIndex = removedIndex;
  let modifyAbleAddedIndex = addedIndex;

  let payloadArr = payload;

  if (!Array.isArray(payload)) {
    payloadArr = [payload];
  }

  payloadArr.forEach((itemToAdd) => {
    if (removedIndex !== null) {
      itemToAdd = result.splice(modifyAbleRemovedIndex, 1)[0];
      modifyAbleRemovedIndex++;
    }

    if (addedIndex !== null) {
      result.splice(modifyAbleAddedIndex, 0, itemToAdd);
      modifyAbleAddedIndex++;
    }
  });

  console.log(result);
  return result;
};

export const generateItems = (count, creator) => {
  const result = [];
  for (let i = 0; i < count; i++) {
    result.push(creator(i));
  }
  return result;
};
